// extracted by mini-css-extract-plugin
export var buttons = "warningPopup-module--buttons--W6QU9";
export var screenCover = "warningPopup-module--screenCover--0-zFQ";
export var topText = "warningPopup-module--topText--3zypV";
export var window = "warningPopup-module--window--ipxgd";